import {  Logo as SourceLogo } from 'SourceComponent/Logo/Logo.component'
import media, { WYSIWYG_MEDIA } from "Util/Media/Media";
import {lazy} from "react";

export const UniversalIcon = lazy(() => import(
    /* webpackMode: "lazy", webpackChunkName: "icons" */
    'Component/UniversalIcon'
    ));

export class Logo extends SourceLogo {

    renderImage() {
        const { imageStatus } = this.state;
        const { src } = this.props;

        if (!src) {
            return this.renderPlaceholderLogo();
        }

        switch (imageStatus) {
        case IMAGE_NOT_FOUND:
        case IMAGE_NOT_SPECIFIED:
            return this.renderPlaceholderLogo();
        default:
            // return super.renderImage();
            return (
                <UniversalIcon
                    src={media('logo.svg', WYSIWYG_MEDIA)}
                    alt="logo"
                    className="Image-Image"
                />
            );
        }
    }

    render() {
        const { imageStatus } = this.state;

        return (
            <div
              block="Image"
              mods={ { imageStatus } }
              mix={ { block: 'Logo' } }
            >
                { this.renderImage() }
            </div>
        );
    }
}

export default Logo;
